export default {
  COLUMN_LAYOUT: 'tree.column-layout',
  CONCLUSION_DETAILED_VIEW: 'tree.person-details-expanded-state',
  EXPANDED_DETAILS_SECTIONS: 'tree.person-details.sections',
  FAMILY_MEMBER_ALL_CHILDREN: 'tree.showAllFamilyMembers',
  HIDE_PERSON_SKIP_CONFIRM: 'tree.person-tools.hidePersonSkipConfirm',
  MATCH_SERVICE: 'match.service',
  PRINT_CONTACT_INFO: 'temple.printContactInfo',
  QUALITY_INDICATOR: 'tree.personR9.qualityIndicator',
  SCPP_SUMMARY_DISMISSED_AT: 'tree.personR9.scppSummaryOverlayDismissedAt',
  SECTION_ORDER: 'tree.section-order',
  SHOW_NAMES_IN_ROMAN_SCRIPT: 'tree.showNamesInRomanScript',
} as const
